const MinimizeIcon = ({ onClick = () => { } }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ariaLabel="Minimize"
            onClick={onClick}
            style={{ cursor: "pointer" }}
        >
            <path
                d="M5 18H19"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
    );
};

const MaximizeIcon = ({ onClick = () => { } }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={{ cursor: "pointer" }}
        >
            <rect
                x="5"
                y="5"
                width="14"
                height="14"
                rx="2"
                stroke="currentColor"
                strokeWidth="2"
            />
        </svg>
    );
};

const CloseIcon = ({ onClick = () => { } }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={{ cursor: "pointer" }}
        >
            <path
                d="M18 6L6 18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M6 6L18 18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
    );
};

const FullscreenIcon = ({ onClick = () => { } }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ariaLabel="Fullscreen"
            onClick={onClick}
            style={{ cursor: "pointer" }}
        >
            <path
                d="M8 5H5v3"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16 5h3v3"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8 19H5v-3"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16 19h3v-3"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export { MinimizeIcon, MaximizeIcon, CloseIcon, FullscreenIcon };